import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { TimeSheetFilter } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  reloadProjectTimeSheet(
    request: Boundaries["reloadProjectTimeSheet"]["request"],
  ): void;
}

function useReloadProjectTimeSheet(filter: TimeSheetFilter): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isReloadProjectTimeSheetRequestPending(filter),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isReloadProjectTimeSheetRequestSuccess(filter),
    ),
    isRequestFailure: useSelector(() =>
      selector.isReloadProjectTimeSheetRequestFailure(filter),
    ),
    reloadProjectTimeSheet: core.reloadProjectTimeSheet,
  };
}

export { useReloadProjectTimeSheet };
